// This file is part of InvenioRDM
// Copyright (C) 2023 CERN.
//
// Invenio App RDM is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

/**
 * Add here all the overridden components of your app.
 */

import { GuidedDepositStatusCard } from "../overrides/GuidedDepositStatusCard";

export const overriddenComponents = {
  // Fix submit-for-review being inert due to stale/over-strict permissions state.
  // This overrides the default status box container for all deposit flows.
  "InvenioAppRdm.Deposit.CardDepositStatusBox.container":
    GuidedDepositStatusCard,
};
